import ApiService from './api_services'

const ReportMeterInformationApi = {
  createOrUpdate: function(formData) {
    return ApiService.post('/report_meter_information', formData)
  },
}

export default ReportMeterInformationApi
